import React from "react";
import { useTranslation } from "react-i18next";
import { FaCalendarCheck, FaWhatsapp } from "react-icons/fa";
import styles from "./DemoModal.module.css";

const DEMO_SERVICE_ID = "f0159974-26e3-4158-99d9-233e300eceff";
const DEMO_BASE = "https://stylon.online/stylon/add-appointment";
const WHATSAPP_URL = "https://wa.me/972533920842";

const PORTAL_ONBOARDING_BASE = "https://portal.stylon.co/onboarding";

/** Forward UTM params from the current page URL to the destination, with fallbacks and button identifier. */
function buildOnboardingUrl(phone) {
  const src = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const dest = new URLSearchParams();

  // Forward landing-page UTM params if present; fall back to defaults
  dest.set("utm_source",   src.get("utm_source")   || "company_site");
  dest.set("utm_medium",   src.get("utm_medium")   || "popup");
  dest.set("utm_campaign", src.get("utm_campaign") || "");
  dest.set("utm_content",  "try_free"); // always tag which button was clicked
  if (src.get("utm_term")) dest.set("utm_term", src.get("utm_term"));

  // Remove empty values to keep URL clean
  for (const [k, v] of [...dest.entries()]) {
    if (!v) dest.delete(k);
  }

  if (phone) dest.set("phone", phone);

  return `${PORTAL_ONBOARDING_BASE}?${dest.toString()}`;
}

const DemoModal = ({ onClose, phone = "" }) => {
  const { t } = useTranslation();

  const demoUrl = `${DEMO_BASE}?service=${DEMO_SERVICE_ID}&ref=demo${phone ? `&phone=${encodeURIComponent(phone)}` : ""}`;
  const onboardingUrl = buildOnboardingUrl(phone);

  return (
    <div className={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close">✕</button>
        <div className={styles.icon}>🎉</div>
        <h2 className={styles.title}>{t("demoModal.title")}</h2>
        <p className={styles.subtitle}>{t("demoModal.subtitle")}</p>
        <div className={styles.actions}>
          <a
            href={demoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnPrimary}
          >
            <FaCalendarCheck />
            {t("demoModal.bookDemo")}
          </a>
          <a
            href={onboardingUrl}
            className={styles.btnSecondary}
          >
            {t("demoModal.tryFree")}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnWhatsapp}
          >
            <FaWhatsapp />
            {t("demoModal.whatsapp")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
